import router from "./router";
import store from "./store";
import { message, Modal } from "ant-design-vue";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie
import { needGetPersonalSetting } from "@/utils/needGetPersonalSetting";
import getPageTitle from "@/utils/get-page-title";
import { getFirstMenu, isTopathExist } from "@/utils/index";
import { tdTracking } from '@/utils/index'
NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login","/ops/wx"]; // no redirect whitelist
let needGetUserSettings = true;
router.beforeEach(async (to: any, from: any, next: any) => {
  // 关闭所有对话框
  const modal: any = Modal;
  modal.destroyAll();

  // start progress bar
  NProgress.start();
  if (to.path === "/login") {
    needGetUserSettings = true;
    let flag = needGetPersonalSetting();
    if (flag) {
      await store.dispatch("user/getSettingByDomainUsingGET");
      next();
      NProgress.done();
    }
  }

  if (from.path === "/login") {
    // 针对登录成功却没能进入系统，并再次换账号登录的情况
    needGetUserSettings = true;
  }
  // 从华为云直接跳转进入系统
  if (to.path === "/huawei/imc") {
    next();
    NProgress.done();
  } else {
    // set page title
    document.title = getPageTitle(to.meta.title);
    const hasToken = getToken();

    if (hasToken) {
      try {
        let currAppData:any = await store.dispatch("permission/getRouteAppCode",to.path);
        let appCode = store.state.app.current;
        if(currAppData && currAppData.appCode && currAppData.appCode != appCode){
          appCode = currAppData.appCode;
          store.dispatch('app/setCurrentApp', currAppData.appCode);
          store.dispatch("app/setAppName", currAppData.appName);
          store.commit("permission/SET_ROUTES", []);
        } 
        if (
          store.state.permission.appRoutes.length == 0 ||
          appCode === "material"
        ) {
          if(!appCode){
            appCode = "console";
          }
          let appName = store.state.app.appName
            ? store.state.app.appName
            : "控制台";
          store.dispatch("app/setAppName", appName);
          await store.dispatch("i18n/initializeLang");
          await store.dispatch("permission/setButtons");
          if (appCode !== "material") {
            const accessRoutes = await store.dispatch(
              "permission/generateRoutes",
              appCode
            );
            // console.log('accessRoutes', accessRoutes)
            store.commit("permission/SET_ROUTES", accessRoutes);
            console.log(appCode,appName,accessRoutes.length?accessRoutes[0].children:[])
            store.commit("permission/SET_APP_ROUTE_MAP",{
              appCode,
              appName,
              routes:accessRoutes.length?accessRoutes[0].children:[]
            });
            // 动态增加路由
            router.addRoutes(
              accessRoutes.concat({
                path: "*",
                redirect: "/404",
              })
            );
            const defaultMenu = isTopathExist(accessRoutes, to.path)
              ? to.path
              : getFirstMenu(accessRoutes, appCode);
            next({ path: defaultMenu, replace: false });
          } else {
            let materialRouterList = await store.dispatch("permission/setWmsRouter");
            store.commit("permission/SET_APP_ROUTE_MAP",{
              appCode,
              appName,
              routes:materialRouterList || []
            });
            // store.commit('permission/SET_ROUTES', [])
          }
        }
        next();
        NProgress.done();
        // 首次进入非登录页且有token的情况下，根据token获取个性化设置
        if (
          (from.path === "/login" || from.path === "/huawei/imc") &&
          to.path !== "/" &&
          needGetUserSettings
        ) {
          await setTimeout(() => store.dispatch("user/getSetting"), 200);
          needGetUserSettings = false;
        }
      } catch (error) {
        await store.dispatch("user/resetToken");
        console.log(111, error);
        message.error(error || "Has Error");
        next(`/login?redirect=${to.path}`);
        NProgress.done();
      }
    } else {
      /* has no token*/
      if (whiteList.indexOf(to.path) !== -1) {
        // in the free login whitelist, go directly
        next();
      } else {
        // other pages that do not have permission to access are redirected to the login page.
        next(`/login?redirect=${to.path}`);
        NProgress.done();
      }
    }
  }
});

router.afterEach((to, from) => {
  // finish progress bar
  // 路由跳转埋点
  var kv = {}
  kv[to.path] = 1
  tdTracking(store.state.app.current,  kv)
  NProgress.done();
});
